import dayjs from 'dayjs'
import { TimeRange } from 'features/systemLens'
import { formatDuration } from 'features/timeSeries'
import React from 'react'
import styled from 'styled-components'

import { ActiveTimeRangeModeTag } from './ActiveTimeRangeModeTag'

const NowTextContainer = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  white-space: nowrap;
`

interface TimeRangeDisplayProps {
  fromTime: dayjs.Dayjs
  toTime: dayjs.Dayjs
  liveTail?: boolean
  timeRange: TimeRange
}

export const TimeRangeDisplay: React.FC<TimeRangeDisplayProps> = ({
  fromTime,
  toTime,
  liveTail,
  timeRange,
}) => {
  if (liveTail === true) {
    return (
      <>
        <span>
          {fromTime.format('MMM DD HH:mm')}
          &nbsp; &ndash; &nbsp;
        </span>
        <NowTextContainer>
          Now
          <ActiveTimeRangeModeTag timeRange={timeRange} liveTail={liveTail} />
        </NowTextContainer>
      </>
    )
  }

  return (
    <>
      <span>
        {fromTime.format('MMM DD HH:mm')}
        &nbsp; &ndash; &nbsp;
      </span>
      <span>
        {toTime.format('MMM DD HH:mm')} ({formatDuration(fromTime, toTime)})
      </span>
      <ActiveTimeRangeModeTag timeRange={timeRange} liveTail={liveTail} />
    </>
  )
}
